module.exports = __webpack_public_path__ + "static/diamond-089212a783dd142252fd568180643394.png";